import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchSuggestions = (params = {}) => {
    return axios.get('/api/v1/suggestions/', { params });
};

export const fetchSuggestion = id => {
    return axios.get(`/api/v1/suggestions/${id}`);
};

export const updateSuggestion = (id, data) => {
    return axios.patch(`/api/v1/suggestions/${id}`, data);
};
